import { usePersistedColumnState } from "lib/@components/managed-columns/use-persisted-column-state"
import { useMemo } from "react"

import {
    DEFAULT_COLUMN_STATE,
    reconcileColumnState,
    pinField,
    toggleVisibility,
    setOrder,
    reorderVisible,
} from "lib/@components/managed-columns/column-state.mjs"

export function useColumnState(storageKey, currentFields, defaultPinnedField = null, minVisible = 1) {
    const defaultState = useMemo(getDefaultState, [defaultPinnedField])
    const [storedColumnState, setStoredColumnState] = usePersistedColumnState(storageKey, defaultState)
    const columnState = useMemo(getCurrentState, [storedColumnState, currentFields])

    return [columnState, { pinColumn, toggleColumnVisibility, applyColumnOrder, applyVisibleOrder, resetColumns }]

    function getDefaultState() {
        return { ...DEFAULT_COLUMN_STATE, pinnedField: defaultPinnedField }
    }

    function getCurrentState() {
        return reconcileColumnState(storedColumnState, currentFields)
    }

    function pinColumn(field) {
        setStoredColumnState(pinField(columnState, field))
    }

    function toggleColumnVisibility(field) {
        setStoredColumnState(toggleVisibility(columnState, field, minVisible))
    }

    function applyColumnOrder(orderedFields) {
        setStoredColumnState(setOrder(columnState, orderedFields))
    }

    function applyVisibleOrder(visibleFields) {
        setStoredColumnState(reorderVisible(columnState, visibleFields))
    }

    function resetColumns() {
        setStoredColumnState({ ...defaultState })
    }
}
